export default __webpack_public_path__ + "static/media/sFface.6da1e40a.svg";